import { api } from './client'

export type ItemDaColeta = {
  campo: string
  rotulo: string

  /** O que o cliente disse — **como ele escreveu**. Nulo = ainda falta. */
  valor: string | null
  coletado: boolean
}

export type Assistencia = {
  /** `orcamento` | `documento` | `rastreio` | `outro`. */
  estagio: string
  itens: ItemDaColeta[]

  /** O primeiro item em branco, virado pergunta. Nula quando não falta nada. */
  proximaPergunta: string | null
  coletados: number
  total: number
}

export const assistencia = {
  /** O id **externo** da conversa — é o que o Chatwoot entrega por `postMessage`. */
  de: (conversaExterna: number) =>
    api.get<Assistencia>(`/assistencia?conversa=${conversaExterna}`),
}
